module.exports = __webpack_public_path__ + "static/img/img5.2c9578d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/img5.jpg
// module id = jw0Z
// module chunks = 1